export default "__VITE_ASSET__abdc0d64__"